let commonMixin = {
  data () {
    return {
      media: undefined
    }
  },
  methods: {
    goMbPage (scode) {
      if (this.isIphone) {
        document.location.href = 'SuperStock://activityGoTo//showStockPopup//' + scode
      } else if (this.isAndroid) {
        window.JSCallBack['activityGoTo']('showStockPopup', scode)
      } else {
        window.JSCallBack['activityGoTo']('showStockPopup', scode)
      }
    },
    goMbNWPage (scode, media) {
      var strJSONvalue = JSON.stringify(
        {
          key: 'showStockPopup',
          code: scode
        }
      )
      if (this.isIphone) {
        if (media === 'heros4') {
          window.webkit.messageHandlers.JSCallBack.postMessage(strJSONvalue)
        } else {
          document.location.href = 'SuperStock://activityGoTo//showStockPopup//' + scode
        }
      } else if (this.isAndroid) {
        if (media === 'heros4') {
          window.JSCallBack.postMessage(strJSONvalue)
        } else {
          window.JSCallBack['activityGoTo']('showStockPopup', scode)
        }
      } else {
        window.JSCallBack['activityGoTo']('showStockPopup', scode)
      }
    }
  },
  computed: {
    isIphone () {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    isAndroid () {
      if (/Android/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    if (this.$route.query.media) {
      this.media = this.$route.query.media
    }
  }
}

export default commonMixin



// WEBPACK FOOTER //
// ./src/mixin/commonMixin.js